<template>
 <div class="container">
  <div class="card">
   <div class="card-header">
    <div class="card-title">
     <fai icon="file-contract"/>&nbsp;Registrar Pagaré
    </div>
   </div>
   <div class="card-body pb-5">
    <sys-form :inputs.sync="promissory_data"/>
   </div>
   <div class="card-footer text-right">
    <button class="btn btn-secondary" @click="$router.push({ name: 'attachment', params: {id: attachmentId}})">
     <fai icon="reply"/> Cancelar
    </button>
    <button class="btn btn-success" @click="saveForm">
     <fai :icon="['far','edit']"/> Guardar
    </button>
   </div>
  </div>
 </div>
</template>

<script>
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'
import promissoriesService from '@/services/promissories'

export default {
  name: 'AttachmentCreatePromissory',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      promissory_data: {
        folio: {
          name: 'Folio de pagaré',
          hint: 'Folio',
          value: '',
          type: 'text',
          size: 12,
          validate: 'required'
        }
      }
    }
  },
  created () {
    this.attachmentId = this.$route.params.id
  },
  methods: {
    saveForm () {
      promissoriesService.post(this.attachmentId, this.processForm(this.promissory_data))
        .then(response => {
          this.$router.push({ name: 'attachment', params: { id: this.attachmentId } })
        })
        .catch(error => {
          console.log(JSON.stringify(error.statusText))
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/attachments/AttachmentCreatePromissory.vue